// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"F_sV g_hv g_ds g_dw g_dH g_cM g_c7","menuItemSub":"F_sW g_cT g_ds g_dH","menuMainLink":"F_sX g_hw g_gm","menuLink":"F_sY g_hw g_gm","Link":"F_rm w_rm w_qL w_q4"};